import addError from '../../../utils/error.jsx';

export function request(id, data) {
    id = parseInt(id, 10);

    return {
        type: 'CUSTOMERS_UPDATE_REQUEST',
        id,
        data
    };
}

export function error(id, errors) {
    id = parseInt(id, 10);
    
    addError(errors);
    return {
        type: 'CUSTOMERS_UPDATE_ERROR',
        id,
        errors
    };
}

export function finish(customer) {
    return {
        type: 'CUSTOMERS_UPDATE_FINISH',
        id: parseInt(customer.id, 10),
        customer
    };
}

export function clear() {
    return {
        type: 'CUSTOMERS_UPDATE_CLEAR'
    };
}
